import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import {
  faFile as faFileRegular,
  faFileImage,
  faObjectUngroup,
} from '@fortawesome/free-regular-svg-icons';
import {
  faCaretDown,
  faFile as faFileSolid,
  faSlidersH,
} from '@fortawesome/free-solid-svg-icons';
import { DirectiveSuperclass } from '@sama/ng-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// eslint-disable-next-line import-whitelist -- allow import since we still need old toolbar until all projects migrate to objects
import { SettingsService } from '../../../core/h3ml/dsl/sensor-fusion/view-settings/settings.service';
import { ViewMode } from '../../../outputs/annotation/annotation-shared/state/root/annotation-state';
import { ToggleButton } from '../../components/toggle-button-group/toggle-button-group.component';
import { KeyboardShortcutService } from '../../misc-services/keyboard-shortcut.service';
import { EventTrackingValueWithSource } from '../../misc-utils';
import { getViewModeStore } from '../../misc-utils/store-utils';
import { AbstractSensorContentStore } from '../../state/abstract-sensor-content-store';

export interface ViewModeOption {
  viewMode: ViewMode;
  tooltip: string;
}

@Component({
  selector: 'h3-layer-view-settings',
  templateUrl: './layer-view-settings.component.html',
  styleUrls: ['./layer-view-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LayerViewSettingsComponent
  extends DirectiveSuperclass
  implements OnInit
{
  @Input({ required: true }) viewModeOptions!: ViewModeOption[];

  store = inject(AbstractSensorContentStore);

  viewMode$!: Observable<ViewMode>;
  buttons$: Observable<ToggleButton[]> = this.getInput$('viewModeOptions').pipe(
    map((options) =>
      options.map((option) => ({
        value: option.viewMode,
        icon: getIcon(option),
        tooltip:
          option.tooltip +
          this.keyboardShortcutService.getTooltipSuffix('cycleViewMode'),
      })),
    ),
  );

  faCaretDown = faCaretDown;
  faSlidersH = faSlidersH;

  private keyboardShortcutService = inject(KeyboardShortcutService);
  private settingsService = inject(SettingsService);

  ngOnInit() {
    this.settingsService.setViewModeOptions(
      this.viewModeOptions.map((o) => o.viewMode),
    );

    this.viewMode$ = getViewModeStore(this.store).$;
  }

  setViewMode(
    mode: ViewMode,
    eventTrackingValue: EventTrackingValueWithSource,
  ) {
    this.settingsService.setViewMode(mode, eventTrackingValue);
  }
}

function getIcon(option: ViewModeOption) {
  switch (option.viewMode) {
    case 'all':
      return faFileImage;
    case 'layers':
      return faFileSolid;
    case 'selected':
      return faObjectUngroup;
    case 'none':
      return faFileRegular;
  }
}
